<div class="row d-flex justify-content-end container-style px-2 py-1">
  <div class="col-auto pt-1 pb-1">
    <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
      [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="newRegister()"></app-custom-button>
  </div>
</div>
<div class="container-style mt-2" *ngIf="!isOpened">
  <app-custom-table [showImport]="true" [showExport]="true" [showRecover]="true" [headers]="header" [data]="data"
    [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="url"
    (onRecoverData)="getAllFamiliesWithPagination()" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)" (onImport)="onImport()" (onExport)="onExport()"
    (onAction)="onAction($event)">
  </app-custom-table>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>
<app-custom-modal #familyImportModal [label]="'Importar Familias'" [width]="'40rem'" [header]="'Importar Familias'"
  [children]="componentFamilyImportModal" (params)="reloadList($event.reload)" hidden>
</app-custom-modal>